import React from 'react';
import moment from 'moment';
import '../utility/styles/print.css';

const getCompanyDetails = () => {
  try {
    return JSON.parse(localStorage.getItem('companyDetails')) || {};
  } catch (error) {
    return {};
  }
};

const PrintOrderSummary = React.forwardRef((props, ref) => {
  const { data, firstDate, SecondDate } = props;
  const company = getCompanyDetails();
  const companyName =
    company.companyName ||
    company.company_name ||
    localStorage.getItem('company') ||
    'Company';
  const companyAddress = [
    company.address,
    company.city,
    company.state,
    company.pinCode || company.pin_code || company.pincode,
  ]
    .filter(Boolean)
    .join(', ');
  const companyContact = [
    company.mobile && `Phone: ${company.mobile}`,
    company.email && `Email: ${company.email}`,
  ]
    .filter(Boolean)
    .join('  •  ');

  return (
    <div ref={ref} id="order-summary-print" className="bill-summary-print">
      <table className="bill-summary-print-table">
        <colgroup>
          {[11, 7, 9, 12, 13, 22, 13, 13].map((columnWidth, index) => (
            <col key={index} style={{ width: `${columnWidth}%` }} />
          ))}
        </colgroup>
        <thead>
          <tr>
            <th colSpan="8" className="print-company-header">
              <div className="print-company-name">{companyName}</div>
              {companyAddress && (
                <div className="print-company-detail">{companyAddress}</div>
              )}
              {companyContact && (
                <div className="print-company-detail">{companyContact}</div>
              )}
              <div className="print-report-heading">
                <span>Order Summary</span>
                <span>
                  {moment(firstDate).format('DD MMM YYYY')} –{' '}
                  {moment(SecondDate).format('DD MMM YYYY')}
                </span>
              </div>
              <div className="print-report-meta">
                <span>All customers</span>
                <span>{data.length} order(s)</span>
              </div>
            </th>
          </tr>
          <tr className="print-column-header">
            <th>Date</th>
            <th>Prefix</th>
            <th>MRC No.</th>
            <th>Booking Order</th>
            <th>Mobile</th>
            <th>Customer Name</th>
            <th>Country</th>
            <th>City</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={`${row.BOOKING_ORDER_NO}-${index}`}>
              <td className="print-center">
                {row.DATE ? moment(row.DATE).format('DD-MM-YYYY') : '—'}
              </td>
              <td className="print-center">{row.PREFIX || '—'}</td>
              <td className="print-center">{row.MRC_NO || '—'}</td>
              <td className="print-center">
                {row.BOOKING_ORDER_NO || '—'}
              </td>
              <td className="print-center">{row.MOBILE || '—'}</td>
              <td>{row.CUSTOMER_NAME || '—'}</td>
              <td>{row.COUNTRY || '—'}</td>
              <td>{row.CITY || '—'}</td>
            </tr>
          ))}
          <tr className="print-total-row">
            <td colSpan="8" className="print-total-label">
              Total Orders: {data.length}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
});

export default PrintOrderSummary;
